import React, { Component, useEffect } from 'react';
import * as firebase from 'firebase';
import '../view/css/eventfeed2.css';
import { EditEvent } from '../model/event_model/EditEvent.js';
import {
    BrowserRouter as Router,
    useLocation,
    Route,
    withRouter,
    Link,
    Redirect
} from "react-router-dom";
import { ProfileSettingsSubscriptions } from '../view/ProfileSettingSubscriptions';
import { updateUserLikes } from '../model/event_model/updateUserLikes';
import { updateIncrement } from '../model/event_model/updateIncrement';
import { addToCalendar } from '../model/calendar_model/addToCalendar';
import { removeLike } from '../model/calendar_model/removeLike';
import { updateDecrement } from '../model/event_model/updateDecrement';
import { removeFromCalendar } from '../model/calendar_model/removeFromCalendar';

export const Eventfeed2 = (props) => {
    const [picture_exists, setPicture] = React.useState("");
    const [event_in_cal, setCal] = React.useState(false);
    const [liked, setLike] = React.useState(false);
    const [number, setNumber] = React.useState(0);
    const [total_num, setTotal] = React.useState(0);
    const [tag, tags_exist] = React.useState([]);
    const [boolean23, setLoveBool] = React.useState(false);
    const [check_once,setCheck] = React.useState(false);
    const [button_false, setFalse] = React.useState(false);
    const [user_null, setNoUser] = React.useState(false);
    const [refresh, setRefresh] = React.useState(false);    


    const user = firebase.auth().currentUser;
    const firestore = firebase.firestore();
    
    useEffect(() => {
        if (props.check_affiliate === false) {
            console.log(props.check_affiliate);
            check_liked();
        }
    });

    useEffect(() => {
        check();
    }, [])

    const tet = async () => {
        const db = firestore.collection("Event").doc(props.title);
        /* db.get().then(function(doc){
             if(number != doc.data().likes){
                 setNumber(doc.data().likes);
             }
         })*/
        const io = await db.get();
        if (io.exists) {
            var integ = io.data().likes;
            setNumber(integ);
            return true;
        }
    }
    useEffect(() => {
        tet();
    });
    const remove_event = async() =>{
      await firestore.collection("Event").doc(props.title).delete();
  
    }

    const unlike_btn = async () => {
        const db = firestore.collection("Users").doc(user.email);
        const wait = await db.get();
        const event = firestore.collection("Event").doc(props.title);
        if (wait.exists) {
            await removeLike(firestore, user, event);
            const decrement = firebase.firestore.FieldValue.increment(-1);
            await updateDecrement(firestore, props, decrement);
            const this_wait = await event.get();
            if (this_wait.exists) {
                setNumber(this_wait.data().likes);
                setLike(false);
            }
        }
    }
   /* const check_for_affiliate =  () => {
        const db = firestore.collection("Users").doc(user.email);
       db.get().then(function(doc) {
           if(doc.data().exists){
               if(doc.data().type == "Affiliate"){
                   setLoveBool(true);
               }
           }
        });
       
        setCheck(true);
    }*/
    const like_btn = async () => {
        const db = firestore.collection("Users").doc(user.email);
        const wait = await db.get();
        const event = firestore.collection("Event").doc(props.title);
        if (wait.exists) {
            const baby = wait.data().liked_events;
            await updateUserLikes(firestore, user, baby, event)
            const increment = firebase.firestore.FieldValue.increment(1);
            await updateIncrement(firestore, props, increment)
            const this_wait = await event.get();
            if (this_wait.exists) {
                setNumber(this_wait.data().likes);
                setLike(true);
            }
        }
    }

    const check_liked = async () => {
        console.log(props.check_affiliate);
        const db = firestore.collection("Users").doc(user.email);
        const db_wait = await db.get();
        if (db_wait.exists) {
            const like = db_wait.data().liked_events;
            const event = firestore.collection("Event").doc(props.title);
            if (like !== undefined ) {
                for (var i = 0; i < like.length; i++) {
                    if (like[i].id === event.id) {
                        setLike(true);
                    }
                }
            }
        }
        setLoveBool(true);
    }
 
    const check = () => {
        //props holds event
        if(user){
        console.log(props.email);
        console.log(user.email);
        const db = firestore.collection("Users").doc(user.email);
        db.get().then(function (doc) {
            if (doc.exists) {
                const event = firestore.collection("Event").doc(props.title);
                const old_events = doc.data().events;
                if (old_events.length != undefined) {
                    for (var i = 0; i < old_events.length; i++) {
                        if (old_events[i].id === event.id) {
                            setCal(true);
                        }
                    }
                }
            } else {
                console.log('user not logged in');
                
            }
        }).catch(function (error) {
            console.log("Error getting document:", error);
        });
    }
    else{
        setNoUser(true);
    }
    }

    const handleClick = () => {
        //props holds event
        console.log("ADD TO CALENDAR CLICKED");
        const db = firestore.collection("Users").doc(user.email);
        db.get().then(function (doc) {
            if (doc.exists) {
                const event = firestore.collection("Event").doc(props.title);
                const old_events = doc.data().events;

                addToCalendar(firestore, user, old_events, event);

                setCal(true);
            } else {
                console.log('user not logged in');
            }
        }).catch(function (error) {
            console.log("Error getting document:", error);
        });
    }
    
    const handleRemove = () => {
        //props holds event
        console.log("ADD TO CALENDAR CLICKED");
        const db = firestore.collection("Users").doc(user.email);
        db.get().then(function (doc) {
            if (doc.exists) {
                const event = firestore.collection("Event").doc(props.title);
                removeFromCalendar(firestore, user, event);
                setCal(false);
            } else {
                console.log('user not logged in');
            }
        }).catch(function (error) {
            console.log("Error getting document:", error);
        });
    }

    const checkUser = async () => {
        const user = await firebase.auth().currentUser;
        return user.email == props.affiliate;
    }

    return (
        <div className="pad" >
            
            <div className="eventTitle">  {props.title} </div>
            <div className="sidecontainer2">
                <div className="eventimage" >
                    {props.picture.length <= 0 ?
                        <img alt="placeholder" className="breezeHolder"
                            src={process.env.PUBLIC_URL + '/digitalassets/logoNoBg.png'} /> :
                            <img alt="uploaded" className="theImages" src={props.picture} />
                        }
                </div>
                <hr className="divider" />
                <div className="EventDetailsContainer">
                    <div className="affiliateName">
                        {props.affiliate}
                    </div>
                    <div className="timeContainer">
                        <div className="time">
                            <b className="bold">Start</b>
                            {props.start}
                        </div>
                        <div className="time">
                            <b className="bold">End</b>
                            {props.end}
                        </div>
                    </div>
                    <div className="location">
                        <b className="bold">Location: </b>
                        {props.location}
                    </div>
                    <div className="eventdescription">
                        {props.description}
                    </div>

                    {!props.affiliate && (props.tags.length > 0 || props.tags.length !== undefined) &&
                        <div className="eventinterest" >
                            Interested in these types of events? Then add
                        {(!props.affiliate && props.tags && props.tags.map((tag) =>
                            <div className="tags"> {tag}, </div>))
                            } tags to your interests and discover if you haven't already!</div>}

                    <div className="ButtonContainer">
                        {(props.check_affiliate === false ) && !user_null &&(!liked ?
                            <button className="cardButton" onClick={like_btn}>
                                Like this event {number}
                            </button> :
                            <button className="cardButton" onClick={unlike_btn}>
                                Unlike this event {number}
                            </button>)}
                        {!event_in_cal && !user_null && (props.check_affiliate == false ) &&
                            <button className="cardButton" onClick={handleClick}>
                                Add to Calendar
                            </button>}
                        {event_in_cal && !user_null && (props.check_affiliate == false ) && 
                            <button className="cardButton" onClick={handleRemove}>
                                Remove from Calendar
                            </button>}
                         {/*props.check_affiliate &&  <button className="cardButton" onClick={remove_event}> Remove Event </button>*/}  
                        {props.check_affiliate && props.email == user.email && 
                            <EditEvent event_title={props.title} noFetchData={props.noFetchData} />}
                        {!props.inaffiliate_view &&
                            <Link
                                className="cardButton"
                                to={{ pathname: `/Affiliate/${props.affiliate}`, state: { id: props.email } }}>
                                View Affiliate
                            </Link>}
                            
                    </div>
                </div>
            </div>
        </div>
    );
}






